import { ANALYTIC_COOKIES } from './constants'
import getCookie from './getCookie'
import isBrowser from './isBrowser'
import setCookie from './setCookie'
import { setInLocalStorageWithExpiry } from './setInLocalStorageWithExpiry'

export const getlbUserId = () => {
  if (!isBrowser()) return

  createLastBrandUserId()
  return getCookie(ANALYTIC_COOKIES.LB_USER_ID)
}

export function createLastBrandUserId() {
  if (!getCookie(ANALYTIC_COOKIES.LB_USER_ID)) {
    console.info('Quince cookies : lb user id is not present, generating to set one')
    const lbUserId = uniqueIdGenerator()
    console.info('Quince cookies : generated lb user id - ', lbUserId)
    setCookie(ANALYTIC_COOKIES.LB_USER_ID, lbUserId)
    setInLocalStorageWithExpiry(ANALYTIC_COOKIES.LB_USER_ID, lbUserId)
    setCookie('_lb_user_first_access', true, 1)
  }
}

// TODO: Change to a better algorithm
export const uniqueIdGenerator = () => {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return `_${Math.random().toString(36).substr(2, 9)}`
}
